import { HelmetProvider } from 'react-helmet-async';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { ruRU } from '@mui/x-date-pickers/locales';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime'
import calendar from 'dayjs/plugin/calendar'
import duration from "dayjs/plugin/duration";
import utc from 'dayjs/plugin/utc'; 
import "dayjs/locale/ru";
import "dayjs/locale/en";
import { AVCallProvider } from './contexts/AVCallContext';
import { getSelectedLanguage } from './services/language_service';
// routes
import "./i18n";
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';

import './App.css';
// ----------------------------------------------------------------------

dayjs.extend(relativeTime);
dayjs.extend(calendar);
dayjs.extend(utc);
dayjs.extend(duration);
dayjs.locale(getSelectedLanguage());

export default function App() {
    return (
        <AVCallProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}
                adapterLocale={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}>
                <HelmetProvider>
                    <ThemeProvider>
                        <ScrollToTop />
                        <StyledChart />
                        <Router />
                    </ThemeProvider>
                </HelmetProvider>
            </LocalizationProvider>
        </AVCallProvider>
    );
}
